import React from "react";
import EmailList from "./EmailList";
import EmailUpdate from "./EmailUpdate";
import EmailCreate from "./EmailCreate";
import { Route, Switch } from "react-router-dom";
class Index extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Switch>
        <Route
          path="/bulk-email/create"
          render={props => (
            <EmailCreate
              {...props}
              userPermissions={this.props.userPermissions}
            />
          )}
        />
        {/* <Route
          path="/bulk-email/create/"
          render={props => (
            <EmailCreate
              {...props}
              userPermissions={this.props.userPermissions}
            />
          )}
        /> */}
        <Route
          path="/bulk-email/update/:id"
          render={props => (
            <EmailUpdate
              {...props}
              userPermissions={this.props.userPermissions}
            />
          )}
        />
        <Route
          path="/bulk-email"
          render={props => (
            <EmailList
              {...props}
              userPermissions={this.props.userPermissions}
            />
          )}
        />
      </Switch>
    );
  }
}

export default Index;
